export enum speakerEnum {
    speaker ='Sprecher'
}